// ScalePlus remains an optional connection dashboard. DNS records stay in Groove.
export const DOMAIN_PORTAL_URL = 'https://domains.scaleplus.gg/';
export const DOMAIN_GUIDE_URL = 'https://domains.scaleplus.gg/help';
export const DOMAIN_PORTAL_FLAG = 'VUE_APP_UNIFIED_DOMAINS_ENABLED';
export const DOMAIN_TOOLS_TAB = 'Domains';
export const DOMAIN_TOOLS_PATH = '/domains';

export function domainPortalEnabled(config = typeof window === 'undefined' ? {} : window.gdEnv || {}) {
  return config[DOMAIN_PORTAL_FLAG] === true || config[DOMAIN_PORTAL_FLAG] === 'true';
}

function normalizedPath(path) {
  if (typeof path !== 'string' || path === '') return '/';
  const bare = path.split('?')[0].split('#')[0].replace(/\/+$/, '');
  return bare || '/';
}

export function isDomainToolsRoute(route) {
  if (!route || typeof route !== 'object') return false;
  return route.name === 'domains' || normalizedPath(route.path) === DOMAIN_TOOLS_PATH;
}

// Open the existing account Domains screen. Never leave for Scale here:
// the portal's way back to Groove is the dashboard, which would loop.
export function openDomainTools(host) {
  if (!host || typeof host !== 'object') return false;
  if (typeof host.editUserDetails === 'function') {
    host.editUserDetails(DOMAIN_TOOLS_TAB);
    return true;
  }
  const root = host.$root;
  if (root && typeof root.$emit === 'function') {
    root.$emit('open-account-modal', DOMAIN_TOOLS_TAB);
    return true;
  }
  return false;
}

export function withDomainPortalMenu(items, { enabled = domainPortalEnabled(), labels = [], navigate } = {}) {
  if (!enabled || !Array.isArray(items)) return items;
  const callback = navigate || function openInAppDomainTools() {
    openDomainTools(this);
  };
  const domainLabels = ['Domains', 'frontend_baselayout_domains', 'frontend_baselayout_settings_domains', ...labels];
  const matches = item => item && domainLabels.some(label => typeof item.text === 'string' && item.text.trim() === label);
  if (items.some(matches)) return items.map(item => matches(item) ? { ...item, callback } : item);
  const firstDivider = items.findIndex(item => item && item.text === 'ruler');
  const position = firstDivider < 0 ? items.length : firstDivider;
  return [...items.slice(0, position), { text: 'Domains', callback }, ...items.slice(position)];
}
